import PropTypes from "prop-types";

import styles from "./InviteResultToast.module.scss";

// Content for the invite confirmation toast. Lives next to the thunk that fires
// it because both of that thunk's callers - the invite modal and Resend Invite
// on the team list - go through it.
//
// Rendered as a node, never as an HTML string: the message interpolates email
// addresses the user typed.
// closeToast is injected by the toast container, which clones element content
// and passes it in. Not something the caller provides.
const InviteResultToast = ({ message, resendEmails, onResend, closeToast }) => {
  const handleResend = () => {
    // Dismiss this toast before the resend raises its own. Toasts stack in a
    // column, so leaving this one up pushes the confirmation down over the
    // modal instead of into the slot at the top.
    closeToast?.();
    onResend(resendEmails);
  };

  return (
    <div className={styles.resultToast}>
      <span>{message}</span>
      {resendEmails.length > 0 && (
        <button
          type="button"
          className={styles.resendLink}
          onClick={handleResend}
          data-testid="invite-resend-link"
        >
          {resendEmails.length === 1 ? "Resend invite" : "Resend invites"}
        </button>
      )}
    </div>
  );
};

InviteResultToast.propTypes = {
  message: PropTypes.string.isRequired,
  resendEmails: PropTypes.arrayOf(PropTypes.string).isRequired,
  onResend: PropTypes.func.isRequired,
  closeToast: PropTypes.func,
};

InviteResultToast.defaultProps = {
  closeToast: undefined,
};

export default InviteResultToast;
